<script setup lang="ts"></script>

<template>
  <section class="body-font container relative text-gray-600">
    <h1 class="title">Info e contatti</h1>

    <div class="flex-row gap-10 md:flex">
      <div class="w-full md:w-1/2">
        <h2 class="subtitle">Come abbonarsi</h2>

        <p class="mt-2">
          L'abbonamento online a Studi Musicali è integrato nell'abbonamento alla rivista in formato cartaceo. Al
          momento non è possibile abbonarsi alla sola rivista online, ma è possibile chiedere di non ricevere più la
          versione cartacea (la quota prevista è comunque la stessa dell'abbonamento completo).
        </p>

        <p class="mt-2">
          Per abbonarsi occorre inviare una email all'indirizzo
          <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a> con la
          richiesta di abbonamento, effettuando il pagamento con bonifico sul:
        </p>

        <ol class="list-inside">
          <li class="mt-5">
            <strong>Conto Corrente Bancario</strong><br />
            IBAN: “IT 31 I 01005 03240 000000009872” - SWIFT/BIC: “BNL II TRR”<br />
            BNL - Gruppo BNP Paribas Agenzia di Via del Corso, 471 - 00186 Roma C/c<br />
            intestato a "Fondazione Accademia Nazionale di Santa Cecilia"<br />
          </li>
        </ol>

        <p class="mt-5">
          <strong>
            Causale: “Abbonamento Studi Musicali per l'anno 20XX”.<br />
            Per le tariffe in vigore si leggano le condizioni di abbonamento riportate di seguito.
          </strong>
        </p>
      </div>

      <div class="mt-5 w-full md:mt-0 md:w-1/2">
        <h2 class="subtitle">Per gli abbonati</h2>

        <p class="mt-2">
          Gli abbonati alla rivista Studi Musicali possono consultare il periodico anche online fornendo al momento
          della sottoscrizione il nominativo e l'indirizzo email di chi si occuperà di gestire gli accessi. È inoltre
          possibile stampare gli articoli o parte di essi.
        </p>

        <p class="mt-2">
          Per qualsiasi informazione o segnalazione di malfunzionamento è necessario rivolgersi ai seguenti contatti:
        </p>

        <ul class="classic-ul">
          <li class="mt-5">
            <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>
          </li>
          <li class="mt-5">tel. +39-06-80242526</li>
          <li class="mt-5">fax +39-06-80242306</li>
        </ul>
      </div>
    </div>

    <hr class="my-10 border-gray-300" />

    <div>
      <h2 class="subtitle">Pubblicità</h2>
      <p class="mt-2">
        Per gli annunci pubblicitari rivolgersi ai seguenti contatti:
        <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>
      </p>
    </div>

    <div class="mt-5">
      <h2 class="subtitle">Condizioni di abbonamento</h2>
      <p class="mt-2">
        Gli abbonati ricevono con cadenza semestrale la rivista Studi Musicali in formato cartaceo e hanno pieno accesso
        alla versione digitale online di tutte le annate, fino all'ultimo numero pubblicato. Si fa presente che i due
        numeri della Rivista sono pubblicati a Giugno e Dicembre dell'anno di riferimento.
      </p>

      <div class="my-5 flex-row md:flex">
        <ul class="classic-ul w-full md:w-1/2">
          <li>Abbonamento Italia - istituzioni: <strong>85,00 euro</strong></li>
          <li>Abbonamento Italia - privati: <strong>70,00 euro</strong></li>
        </ul>

        <ul class="classic-ul w-full md:w-1/2">
          <li>Abbonamento estero - istituzioni: <strong>110,00 euro</strong></li>
          <li>Abbonamento estero - privati: <strong>90,00 euro</strong></li>
        </ul>
      </div>

      <p>
        Le spese di spedizione in abbonamento sono a carico dell'editore. Per le quote di abbonamento alle annate
        precedenti si prega di contattare:
        <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>
      </p>
    </div>

    <div class="mt-5">
      <h2 class="subtitle">Numeri arretrati e singoli fascicoli</h2>

      <p>
        È possibile acquistare i numeri arretrati per annata (al costo di 90,00 euro) o per singolo fascicolo (al costo
        di 50,00 euro).
      </p>
    </div>
  </section>
</template>
